import { useEffect } from 'react';
import moment from 'moment';
import 'moment/locale/zh-tw';
import 'moment/locale/zh-cn';
import 'moment/locale/ja';
import { useTranslation } from 'react-i18next';
import '../../app/i18n';

function InitI18n({ children }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    moment.locale(i18n.language, {
      weekdaysShort:
        i18n.services.resourceStore.data[
          i18n.language
        ].momentFormat.weekdaysShort.split('_'),
      relativeTime:
        i18n.services.resourceStore.data[i18n.language].momentFormat
          .relativeTimeFormat,
    });
  }, [i18n.language]);
  return <>{children}</>;
}

export default InitI18n;
